<template>
  <div class="search-file" v-show="showComponent == 'ask'">
    <div class="file-filter">
      <el-tabs v-model="searchObj.pro">
        <el-tab-pane label="术语" name="0"></el-tab-pane>
        <el-tab-pane label="问答" name="1"></el-tab-pane>
      </el-tabs>
    </div>
    <div class="search-detail-content">
      <ask-card @delete="doDeleteFavorite" @add="doAddFavorite" :cardData="item" v-for="(item, index) in currentDocList" :key="index"></ask-card>
      <div class="page-num">
        <el-pagination
          v-if="currentDocList.length"
          small
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :page-size="20"
          :total="totalNumber">
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import api from '../../../api/index.js'
// import { loginUtil, monitor } from '../../../util/index.js'
// import subscribeTips from '../subscribeTips.vue'
import askCard from '../search/askCard.vue'
export default {
  props: ['searchQObj', 'showComponent'],
  data () {
    return {
      searchObj: {
        pro: '0',
        searchClass: [],
        searchAreaClass: [],
        classMenuData: [],
        classAreaMenuData: []
      },
      totalNumber: 100,
      listLoading: false,
      noMore: false,
      loadingTip: false,
      currentDocList: [],
      // loginFlag: loginUtil.checkoutLogin(),
      showFolderWindow: false,
      favarFolderList: [],
      fileId: ''
    }
  },
  mounted () {
    this.doGetMenus()
  },
  methods: {
    handelList (successFlag) {
      if (successFlag) {
        this.showFolderWindow = false
        this.fileItem.collectionType = true
      }
    },
    // async doAddFavorite (item) {
    //   if (!await this.gotoLogin()) return
    //   if (this.favorList.totalNumber >= 200) {
    //     this.$message({
    //       message: '我的收藏已到达200条嘞，删掉一条再添加吧~',
    //       type: 'warning'
    //     })
    //     return
    //   }
    //   if (!this.favarFolderList.length) {
    //     this.loading = this.$loading({
    //       lock: true,
    //       text: 'Loading',
    //       spinner: 'el-icon-loading',
    //       background: 'rgba(256, 256, 256, 0.7)'
    //     })
    //     api.addFavoriteAsk({
    //       termId: item.termId || item.id,
    //       folderId: -1
    //     }).then(res => {
    //       this.loading.close()
    //       if (res.code === 200 || res.code === 2006) {
    //         item.collectionType = true
    //         this.doGetFavoriteList()
    //       } else {
    //         this.$message({
    //           message: res.message || '收藏失败，请稍后再试',
    //           type: 'warning'
    //         })
    //       }
    //     })
    //   } else {
    //     this.fileId = item.termId || item.id
    //     this.fileItem = item
    //     this.showFolderWindow = true
    //   }
    // },
    // async doDeleteFavorite (item, fromFav) {
    //   if (!await this.gotoLogin()) return
    //   this.loading = this.$loading({
    //     lock: true,
    //     text: 'Loading',
    //     spinner: 'el-icon-loading',
    //     background: 'rgba(256, 256, 256, 0.7)'
    //   })
    //   api.deleteFavoriteAsk({
    //     termId: item.termId || item.id
    //   }).then(res => {
    //     item.collectionType = false
    //     this.loading.close()
    //     this.doGetFavoriteList()
    //     if (fromFav) {
    //       this.refreshDetail()
    //     }
    //   })
    // },
    // doGetFavoriteList () {
    //   if (!this.loginFlag) return
    //   api.getFavoriteListAsk({
    //   }).then(res => {
    //     if (res.code === 200) {
    //       this.favorList = res.data
    //     }
    //   })
    //   api.getFavoriteListFolderAsk({}).then(res => {
    //     if (res.code === 200) {
    //       this.favarFolderList = res.data
    //     }
    //   })
    // },
    afterPDFOpen () {
      // this.loading && this.loading.close()
      this.percent = 0
    },
    doGetMenus () {
      api.getMenusAsk({
        type: 0
      }).then(res => {
        if (res && res.code === 200) {
          this.searchObj.classMenuData = JSON.parse(JSON.stringify(res.data[0].child).replace(/"child":\[\],/g, ''))
        }
      })
      api.getMenusAsk({
        type: 1
      }).then(res => {
        if (res && res.code === 200) {
          this.searchObj.classAreaMenuData = JSON.parse(JSON.stringify(res.data[0].child).replace(/"child":\[\],/g, ''))
        }
      })
    },
    handleClassChange () {
      this.querySearchAsync(true)
    },
    handleCurrentChange (v) {
      console.log(v)
      this.pageNo = v
      this.querySearchAsync()
    },
    querySearchAsync (resetFlag) {
      if (!this.searchQ) {
        return
      }
      // monitor('搜索文件', 'ask')
      if (resetFlag) {
        this.pageNo = 1
        this.currentDocList = []
        this.listLoading = true
        this.noMore = false
      }
      if (this.loadingTip || this.noMore) return
      this.loadingTip = true
      // this.loading = this.$loading({
      //   lock: true,
      //   spinner: 'none',
      //   background: 'rgba(0, 0, 0, 0)'
      // })
      api.getSuggestAsk({
        qaTermType: this.searchObj.pro,
        name: this.searchQ,
        pages: 20,
        pageNo: this.pageNo,
        id: this.searchQObj.idSeach,
        classa: {
          0: [...this.searchObj.searchClass].join(','),
          1: [...this.searchObj.searchAreaClass].join(',')
        }[this.searchObj.pro] || ''
      }).then(res => {
        // this.loading.close()
        this.listLoading = false
        this.loadingTip = false
        if (res && res.code === 200) {
          this.totalNumber = res.data.totalNumber
          this.currentDocList = res.data.list
        } else {
          this.$message({
            type: 'error',
            message: res.message || '服务错误，请稍后再试'
          })
        }
      })
    },
    gotoLogin () {
      return new Promise(resolve => {
        if (this.loginFlag) {
          resolve(true)
        } else {
          this.$router.replace('/login')
          resolve(false)
        }
      })
    }
  },
  watch: {
    showComponent (val) {
      if (val === 'ask' && !this.currentDocList.length && !this.noMore) {
        // this.doGetFavoriteList()
        this.querySearchAsync(true)
      }
    },
    searchQObj (val) {
      this.searchQ = val.q
      this.currentDocList = []
      this.noMore = false
      if (this.showComponent === 'ask') {
        // this.doGetFavoriteList()
        this.querySearchAsync(true)
      }
    },
    searchObj: {
      handler: function () {
        this.querySearchAsync(true)
      },
      deep: true
    }
  },
  components: {
    // subscribeTips,
    askCard
  }
}
</script>

<style lang="scss">
// .search-file {
//   display: flex;
//   flex: 1;
//   flex-direction: column;
//   height: 100px;
//   .file-filter {
//     width: 100%;
//     flex: 0 0 auto;
//     display: flex;
//     justify-content: Space-between;
//     align-items: center;
//     flex-wrap: wrap;
//     padding: 8px 12px;
//     background: #f4f5f6;
//   }
// }
</style>
